import { ApiProperty } from "@nestjs/swagger";

export class SoSoItemRequest{
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    saleOrderItemId:number;
    @ApiProperty()
    plantId:number;
}